<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-4">
          <h1 class="mt-5">
            Data Layouts
            <i *ngIf="loadingData" class="fas fa-spinner fa-pulse"></i>
          </h1>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <mat-select [(ngModel)]="selectedEndPoint" (selectionChange)="endPointChanged($event)">
            <mat-option *ngFor="let endPoint of allEndPoints" [value]="endPoint">{{endPoint.title}}</mat-option>
          </mat-select>
        </div>
        <div class="col-md-2" style="margin-top: 6px">
          <a href="#" (click)="createLayout();"><span class="fas fa-file" title="Create New Layout">&nbsp;&nbsp;Create New Layout</span></a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 mainLabel"></div>
        <div class="col-md-3 mainLabel">Layout Name</div>
        <div class="col-md-3 mainLabel">Owner</div>
        <div class="col-md-4 mainLabel">Export Status</div>
      </div>
      <ng-container *ngIf="selectedEndPoint && currentLayouts">
        <ng-container *ngFor="let layout of currentLayouts">
          <div class="row table-row">
            <div class="col-md-2" style="margin-top: 5px">
              <a href="#" (click)="exportNow(layout)"><span class="fas fa-print" title="Configure & Export Now"></span></a>&nbsp;
              <ng-container *ngIf="layout.allowEditing">
                <a href="#" (click)="editLayout(layout)"><span class="fas fa-edit" title="Edit"></span></a>&nbsp;
              </ng-container>
              <ng-container *ngIf="layout.isOwner">
                <a href="#" (click)="deleteLayout(layout)"><span class="fas fa-trash" title="Delete"></span></a>&nbsp;
              </ng-container>
              <ng-container *ngIf="!layout.recurring">
                <a href="#" (click)="createRecurring(layout)"><span class="fas fa-calendar-plus" title="Create Scheduled Export"></span></a>
              </ng-container>
              <ng-container *ngIf="layout.recurring">
                <a href="#" (click)="editRecurring(layout.recurring)"><span class="fas fa-calendar-day" title="Edit Scheduled Report"></span></a>&nbsp;
                <a href="#" (click)="deleteRecurring(layout.recurring)"><span class="fas fa-calendar-times" title="Delete Scheduled Report"></span></a>
              </ng-container>
            </div>
            <div class="col-md-3">{{ layout.name }}</div>
            <div class="col-md-3">{{ layout.createdBy }} / {{ layout.organizationName }}</div>
            <div class="col-md-4">
              {{ getExportStatus(layout) }}
              <ng-container *ngIf="getLatestUrl(layout) !== ''">
                <a target="_blank" [href]="getLatestUrl(layout)"><b> [Download] </b></a>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
